module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/star_gold-c3e2a18d2e8d3af20ce44ed5d7558d0a.svg";